import React from "react";

import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

import psce1 from "../../logos/photos/IMG-97de6647103ec282b8cc6b20e3fcd9cb-V_edit_237836303499645.jpg"




export default function Catastrophic() {

  
  return (
    <Layout>
      <Navbar  />
      <PageHeader />
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="about-content-left section-heading">
                <h3 style={{color:'#e95d04'}}>
               PANTHEON Presented at "Global Catastrophic Risks" Event in Serres
                                 </h3>
              <p><a href="https://kemea.gr/en/">The Centre for Security Studies (KEMEA)</a> participated in the <em>&ldquo;Global Catastrophic Risks&rdquo;</em> event, held on 3&ndash;4 April 2025 in Serres, Greece. The event was organised by the International Hellenic University and brought together key stakeholders in the field of civil protection and security.</p>
<p>As part of the event, an internal meeting of the Working Groups 2 (<em>High Risk Hazards and CBRNE</em>) and 3 (<em>Risk, Resilience and Emergency/Crisis Management</em>) of the CEN Technical Committee 391: Societal and Citizen Security took place.</p>
<p>KEMEA's participation aimed to raise awareness of the PANTHEON project among relevant stakeholders, including first responders and civil protection organisations. More importantly, KEMEA presented proposals to the working groups for potential future standardisation based on the findings of the project&mdash;particularly those stemming from WP2: PANTHEON Approach for Building Disaster-Resilient Communities.</p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="about-content-right">
                <img
                  src={psce1}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />
            
            
              
              </div>
            </div>
          </div>
        </div>
      </section>
  

      <Footer space />
    </Layout>
  );
}
